/**
 * moroccanCities.js — Liste des villes marocaines pour les selects de l'application.
 * Utilisé dans : Search.jsx (filtre ville), AgencyDashboard.jsx (publication voiture),
 * CityCombobox.jsx, et tout autre composant nécessitant une sélection de ville.
 */

export const MOROCCAN_CITIES = [
	'Agadir',
	'Al Hoceïma',
	'Amizmiz',
	'Arfoud',
	'Asilah',
	'Azilal',
	'Azrou',
	'Béni Mellal',
	'Ben Slimane',
	'Benguérir',
	'Berkane',
	'Berrechid',
	'Boujdour',
	'Boulemane',
	'Casablanca',
	'Chefchaouen',
	'Chichaoua',
	'Dakhla',
	'El Hajeb',
	'El Jadida',
	'El Kelâa des Sraghna',
	'Errachidia',
	'Essaouira',
	'Fès',
	'Figuig',
	'Fnideq',
	'Guelmim',
	'Guercif',
	'Ifrane',
	'Imzouren',
	'Inezgane',
	'Jerada',
	'Kénitra',
	'Khemisset',
	'Khenifra',
	'Khouribga',
	'Ksar El Kébir',
	'Laâyoune',
	'Larache',
	'Marrakech',
	'M\'diq',
	'Meknès',
	'Midelt',
	'Mohammédia',
	'Moulay Idriss Zerhoun',
	'Nador',
	'Ouarzazate',
	'Ouezzane',
	'Oujda',
	'Oulad Teïma',
	'Rabat',
	'Safi',
	'Salé',
	'Séfrou',
	'Settat',
	'Sidi Bennour',
	'Sidi Ifni',
	'Sidi Kacem',
	'Sidi Slimane',
	'Skhirat',
	'Smara',
	'Souk El Arbaa',
	'Tafraout',
	'Tan-Tan',
	'Tanger',
	'Taounate',
	'Taourirt',
	'Taroudant',
	'Taza',
	'Témara',
	'Tétouan',
	'Tinghir',
	'Tiznit',
	'Youssoufia',
	'Zagora',
];
